/**
 * Сравнение версий Bot API.
 *
 * Нужно потому, что клиенты Telegram обновляются у людей, а не у нас:
 * на одном телефоне DeviceOrientation есть, на другом — нет, и оба
 * пользователя открывают одно и то же приложение. Проверять наличие метода
 * недостаточно — Telegram добавляет заглушки, которые молча ничего не делают.
 */

/** Больше или равно ли `have` версии `want`. Обе — вида "8.0" или "7.10". */
export function atLeast(have: string, want: string): boolean {
  const a = have.split('.').map(Number)
  const b = want.split('.').map(Number)

  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    // "7.10" > "7.9": сравниваем числами, а не строками. Строковое сравнение
    // здесь даёт ровно обратный ответ и ломается ровно один раз в жизни
    // проекта — на десятом минорном релизе.
    const x = a[i] ?? 0
    const y = b[i] ?? 0
    if (x !== y) return x > y
  }
  return true
}
